import Vue from 'vue';
import VueRouter from 'vue-router';
//老师路由
const Home = () => import('@/components/Home');
const NetworkTest = () => import('@/components/networkTest');
const HomePage = () => import('@/components/HomePage/HomePage');
const AllAnnouncement = () => import('@/components/HomePage/AllAnnouncement');
const AnnouncementDetail = () =>
  import('@/components/HomePage/AnnouncementDetail');
const Schedule = () => import('@/components/Schedule/ScheduleManage');
const OperationSlot = () => import('@/components/Schedule/OperationSlot');
const Timetable = () => import('@/components/Timetable/Timetable');
const MakeComment = () => import('@/components/Timetable/MakeComment');
const AssessComment = () => import('@/components/Timetable/AssessComment');
const StudyReport = () => import('@/components/StudentReport');
const OcComment = () => import('@/components/Timetable/OcComment');
const StudentDetail = () => import('@/components/Timetable/StudentDetail');
const FilePage = () => import('@/components/Timetable/FilePage');
const PreBooked = () => import('@/components/PreBooked');
const TrainingMaterial = () =>
  import('@/components/TrainingMaterial/TrainingMaterial');
const TrainingDetail = () =>
  import('@/components/TrainingMaterial/TrainingDetail');
const Policy = () => import('@/components/Policy/Policy');
const Profile = () => import('@/components/Profile/Profile');
const Suggestions = () => import('@/components/Suggestions/Suggestions');
const SuggestDetail = () => import('@/components/Suggestions/SuggestDetail');
const NoviceGuide = () => import('@/components/NoviceGuide/NoviceGuide');
const ImproveInformation = () => import('@/components/ImproveInfo');
const EditingInfo = () => import('@/components/EditingInfo');
const Agreement = () => import('@/components/Agreement');
const Login = () => import('@/components/Login');
const BeginnerGuide = () => import('@/components/BeginnerGuide');
const Hiring = () => import('@/components/Overseas/OverseasIndex');
const ApplyTable = () => import('@/components/Overseas/ApplyTable');
const MoreLink = () => import('@/components/MoreLink');
const Leave = () => import('@/components/Leave');
const DingTalkBinding = () => import('@/components/DingTalk/index');
const StudyPlan = () => import('@/components/Timetable/StudyPlan');
const EditStudyPlan = () =>
  import('@/components/Timetable/StudyPlan/EditStudyPlan');
const ClassTool = () => import('@/components/ClassTool');

//代理路由
const AgtHome = () => import('@/components-agent/Home');
const AgtPayroll = () => import('@/components-agent/Payroll');
const ScheduledClasses = () => import('@/components-agent/ScheduledClasses');
const AssessReport = () =>
  import('@/components-agent/ScheduledClasses/components/AssessReport');
const StudentFeedback = () => import('@/components-agent/StudentFeedback');
const ClassStatisticsPage = () =>
  import('@/components-agent/ClassStatisticsPage');
const StatisticsPage = () => import('@/components-agent/StatisticsPage');
const ChangePassword = () => import('@/components-agent/ChangePassword');
const AgtPolicy = () => import('@/components-agent/Policy');
const Instructions = () => import('@/components-agent/Instructions');
const StudentHistory = () => import('@/components-agent/StudentHistory');
const TutorStatistics = () => import('@/components-agent/TutorStatistics');
const AgtAnnouncementDetail = () =>
  import('@/components-agent/Announcement/AnnouncementDetail');
const AgtAnnouncementList = () =>
  import('@/components-agent/Announcement/AnnouncementList');
const ResignationApplication = () =>
  import('@/components-agent/ResignationApplication/index');

Vue.use(VueRouter);
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/networkTest',
    name: 'NetworkTest',
    component: NetworkTest
  },
  {
    //海外老师页面
    path: '/hiring',
    name: 'Hiring',
    component: Hiring
  },
  {
    //海外老师页面
    path: '/apply-table',
    name: 'ApplyTable',
    component: ApplyTable
  },
  {
    path: '/more-link',
    name: 'MoreLink',
    component: MoreLink
  }
];

export const asyncTeacherEdit = [
  {
    path: '/',
    redirect: '/more-info'
  },
  {
    //完善资料页面
    path: '/more-info',
    name: 'ImproveInformation',
    component: ImproveInformation,
    redirect: '/more-info/editing-info',
    children: [
      {
        path: 'editing-info',
        name: 'EditingInfo',
        component: EditingInfo,
        meta: {
          parent: 'editing-info',
          menu: '4'
        }
      },
      {
        path: 'agreement-new',
        name: 'Agreement',
        component: Agreement,
        meta: {
          parent: 'agreement-new',
          menu: '4'
        }
      },
      {
        path: 'training-material-new',
        name: 'TrainingMaterialNew',
        component: TrainingMaterial,
        meta: {
          parent: 'training-material-new',
          menu: '4'
        }
      },
      {
        path: 'training-detail-new',
        name: 'TrainingDetailNew',
        component: TrainingDetail,
        meta: {
          parent: 'training-material-new',
          menu: '4'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/more-info'
  }
];

export const asyncTeacherRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    // 腾讯云客户端下载页
    path: '/txyClassTool',
    name: 'ClassTool',
    component: ClassTool
  },
  {
    //教材预览页面
    path: '/file-page',
    name: 'FilePage',
    component: FilePage
  },
  {
    //合同引导页
    path: '/beginner-guide',
    name: 'ImproveInformation',
    component: ImproveInformation,
    redirect: '/beginner-guide',
    children: [
      {
        path: '/',
        name: 'BeginnerGuide',
        component: BeginnerGuide,
        meta: {
          parent: 'beginner-guide',
          menu: '5'
        }
      }
    ]
  },
  {
    //老师端路由
    path: '/home',
    name: 'Home',
    component: Home,
    redirect: '/home/page',
    children: [
      {
        path: 'page',
        name: 'HomePage',
        component: HomePage,
        meta: {
          parent: 'home-page',
          menu: '1'
        }
      },
      {
        path: 'all-announcement',
        name: 'AllAnnouncement',
        component: AllAnnouncement,
        meta: {
          parent: 'home-page',
          menu: '1',
          keepAlive: true
        }
      },
      {
        path: 'announcement-detail',
        name: 'AnnouncementDetail',
        component: AnnouncementDetail,
        meta: {
          parent: 'home-page',
          menu: '1'
        }
      },
      {
        path: 'schedule',
        name: 'Schedule',
        component: Schedule,
        meta: {
          parent: 'schedule',
          menu: '1'
        }
      },
      {
        path: 'operation-slot',
        name: 'OperationSlot',
        component: OperationSlot,
        meta: {
          parent: 'schedule',
          menu: '1'
        }
      },
      {
        path: 'study-report',
        name: 'StudyReport',
        component: StudyReport,
        meta: {
          parent: 'study-report',
          menu: '1'
        }
      },
      {
        path: 'timetable',
        name: 'Timetable',
        component: Timetable,
        meta: {
          parent: 'timetable',
          menu: '1'
        }
      },
      {
        path: 'make-comment',
        name: 'MakeComment',
        component: MakeComment,
        meta: {
          parent: 'timetable',
          menu: '1'
        }
      },
      {
        path: 'assess-comment',
        name: 'AssessComment',
        component: AssessComment,
        meta: {
          parent: 'timetable',
          menu: '1'
        }
      },
      {
        path: 'oc-comment',
        name: 'OcComment',
        component: OcComment,
        meta: {
          parent: 'timetable',
          menu: '1'
        }
      },
      {
        path: 'study-plan',
        name: 'StudyPlan',
        component: StudyPlan,
        meta: {
          parent: 'timetable',
          menu: '1'
        }
      },
      {
        path: 'edit-study-plan',
        name: 'EditStudyPlan',
        component: EditStudyPlan,
        meta: {
          parent: 'timetable',
          menu: '1'
        }
      },
      {
        path: 'student-detail',
        name: 'StudentDetail',
        component: StudentDetail,
        meta: {
          parent: 'timetable',
          menu: '1'
        }
      },
      {
        path: 'pre-booked',
        name: 'PreBooked',
        component: PreBooked,
        meta: {
          parent: 'pre-booked',
          menu: '1'
        }
      },
      {
        path: 'training-material',
        name: 'TrainingMaterial',
        component: TrainingMaterial,
        meta: {
          parent: 'training-material',
          menu: '1'
        }
      },
      {
        path: 'training-detail',
        name: 'TrainingDetail',
        component: TrainingDetail,
        meta: {
          parent: 'training-material',
          menu: '1'
        }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: {
          parent: 'profile',
          menu: '1'
        }
      },
      {
        path: 'policy',
        name: 'Policy',
        component: Policy,
        meta: {
          parent: 'policy',
          menu: '1'
        }
      },
      {
        path: 'leave',
        name: 'Leave',
        component: Leave,
        meta: {
          parent: 'leave',
          menu: '1'
        }
      },
      {
        path: 'suggestions',
        name: 'Suggestions',
        component: Suggestions,
        meta: {
          parent: 'suggestions',
          menu: '1'
        }
      },
      {
        path: 'suggest-detail',
        name: 'SuggestDetail',
        component: SuggestDetail,
        meta: {
          parent: 'suggestions',
          menu: '1'
        }
      },
      {
        path: 'ding-talk-binding',
        name: 'DingTalkBinding',
        component: DingTalkBinding,
        meta: {
          parent: 'ding-talk-binding',
          menu: '1'
        }
      },
      {
        //建议导航
        path: '/novice-guide',
        name: 'NoviceGuide',
        component: NoviceGuide,
        meta: {
          parent: 'novice-guide',
          menu: '2'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/home'
  }
];

export const asyncAgentRoutes = [
  {
    path: '/',
    redirect: '/agt-home'
  },
  {
    //代理端路由
    path: '/agt-home',
    name: 'AgtHome',
    component: AgtHome,
    redirect: '/agt-home/payroll',
    children: [
      {
        path: 'payroll',
        name: 'AgtPayroll',
        component: AgtPayroll,
        meta: {
          parent: 'payroll',
          menu: '3'
        }
      },
      {
        path: 'scheduled-classes',
        name: 'ScheduledClasses',
        component: ScheduledClasses,
        meta: {
          parent: 'scheduled-classes',
          menu: '3'
        }
      },
      {
        path: 'assess-report',
        name: 'AssessReport',
        component: AssessReport,
        meta: {
          parent: 'scheduled-classes',
          menu: '3'
        }
      },
      {
        path: 'student-feedback',
        name: 'StudentFeedback',
        component: StudentFeedback,
        meta: {
          parent: 'student-feedback',
          menu: '3'
        }
      },
      {
        path: 'class-statistics-page',
        name: 'ClassStatisticsPage',
        component: ClassStatisticsPage,
        meta: {
          parent: 'class-statistics-page',
          menu: '3'
        }
      },
      {
        path: 'tutor-statistics',
        name: 'TutorStatistics',
        component: TutorStatistics,
        meta: {
          parent: 'class-statistics-page',
          menu: '3'
        }
      },
      {
        path: 'statistics-page',
        name: 'StatisticsPage',
        component: StatisticsPage,
        meta: {
          parent: 'statistics-page',
          menu: '3'
        }
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
          parent: 'change-password',
          menu: '3'
        }
      },
      {
        path: 'agt-policy',
        name: 'AgtPolicy',
        component: AgtPolicy,
        meta: {
          parent: 'agt-policy',
          menu: '3'
        }
      },
      {
        path: 'instructions',
        name: 'Instructions',
        component: Instructions,
        meta: {
          parent: 'instructions',
          menu: '3'
        }
      },
      {
        path: 'student-history',
        name: 'StudentHistory',
        component: StudentHistory,
        meta: {
          parent: 'scheduled-classes',
          menu: '3'
        }
      },
      {
        path: 'agt-announcement-detail',
        name: 'AgtAnnouncementDetail',
        component: AgtAnnouncementDetail,
        meta: {
          menu: '3'
        }
      },
      {
        path: 'agt-announcement-list',
        name: 'AgtAnnouncementList',
        component: AgtAnnouncementList,
        meta: {
          menu: '3'
        }
      },
      {
        path: 'resignation-application',
        name: 'ResignationApplication',
        component: ResignationApplication,
        meta: {
          parent: 'resignation-application',
          menu: '3'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/agt-home'
  }
];

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: 'teacher',
    scrollBehavior(to, from, savePosition) {
      if (savePosition) {
        return savePosition;
      } else {
        return {
          x: 0,
          y: 0
        };
      }
    },
    routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/config/router.js